import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="relative w-full bg-[#1c1f22] text-gray-300 border-t border-gray-700 overflow-hidden">

      {/* Glossy Strip */}
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.06),transparent)] pointer-events-none"></div>

      <div className="relative max-w-screen-xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-12">

        {/* Company Info */}
        <div>
          <h3 className="text-lg font-bold text-[#87c3bc] mb-4 tracking-wide">
            ISIN
          </h3>
          <p className="text-sm leading-relaxed text-gray-400">
            Integrated Solutions for Intelligent Networks.  
            Delivering enterprise-level IT, networking, and infrastructure solutions.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold text-gray-200 mb-4 tracking-wide">
            Quick Links
          </h3>

          <div className="flex flex-col space-y-2 text-sm">
            {[
              { to: "/", label: "Home" },
              { to: "/", label: "About Us" },//about
              { to: "/", label: "Services" },//services
              { to: "/", label: "Contact" },//contact
            ].map((item, i) => (
              <Link
                key={i}
                to={item.to}
                className="group w-fit hover:text-white transition-colors"
              >
                <span className="relative">
                  {item.label}
                  <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-[#87c3bc] transition-all duration-300 group-hover:w-full"></span>
                </span>
              </Link>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold text-gray-200 mb-4 tracking-wide">
            Contact
          </h3>
          <p className="text-sm text-gray-400">info@isin-eg.com</p>
          <p className="text-sm text-gray-400 mt-2">+20 100 000 0000</p>
        </div>

        {/* LinkedIn */}
        <div>
          <h3 className="text-lg font-semibold text-gray-200 mb-4 tracking-wide">
            Follow Us
          </h3>

          <a
            href="https://www.linkedin.com/company/106354681/admin/dashboard/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#87c3bc] text-3xl transition-colors duration-300 inline-block"
          >
            <FaLinkedin />
          </a>
        </div>
      </div>

      {/* Divider Line */}
      <div className="border-t border-gray-700"></div>

      <div className="py-5 text-center text-xs text-gray-500">
        © {new Date().getFullYear()}{" "}
        <span className="font-semibold text-[#87c3bc]">ISIN</span> — All Rights Reserved.
      </div>

      {/* Subtle bottom glow */}
      <div className="absolute -bottom-20 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-[#87c3bc]/10 blur-[120px] rounded-full pointer-events-none"></div>
    </footer>
  );
};

export default Footer;
